import { render, staticRenderFns } from "./MakeupApproval.vue?vue&type=template&id=2262bf28&scoped=true"
import script from "./MakeupApproval.vue?vue&type=script&lang=js"
export * from "./MakeupApproval.vue?vue&type=script&lang=js"
import style0 from "./MakeupApproval.vue?vue&type=style&index=0&id=2262bf28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2262bf28",
  null
  
)

export default component.exports